/* "How Live Breaks Work" modal + new-visitor slide-in tab. Markup: snippets/ua-how-it-works.liquid */
(function () {
  if (window.__uaHiw) return;
  window.__uaHiw = true;

  var HASH = '#how-live-breaks-work';
  var DISMISS_KEY = 'uaHiwTabDismissed'; /* localStorage: closed with the x, never show again */
  var SEEN_KEY = 'uaHiwTabHidden';       /* sessionStorage: opened the video, hide for this visit */
  var TAB_DELAY_MS = 2500;

  var modal = document.getElementById('how-live-breaks-work');
  if (!modal) return;
  var panel = modal.querySelector('.ua-hiw__panel');
  var scroller = modal.querySelector('.ua-hiw__scroll');
  var tab = document.querySelector('.ua-hiw-tab');
  var lastFocus = null;

  /* escape the hero's stacking context so the fixed layers sit above everything */
  document.body.appendChild(modal);
  if (tab) document.body.appendChild(tab);

  function ss(method, key, val) {
    try { return window.sessionStorage[method](key, val); } catch (e) { return null; }
  }

  function ls(method, key, val) {
    try { return window.localStorage[method](key, val); } catch (e) { return null; }
  }

  function track(name, source) {
    var data = { source: source || 'unknown' };
    try { if (window.Shopify && Shopify.analytics && Shopify.analytics.publish) Shopify.analytics.publish(name, data); } catch (e) {}
    try { (window.dataLayer = window.dataLayer || []).push({ event: name, hiw_source: data.source }); } catch (e) {}
  }

  function playVideo() {
    var v = modal.querySelector('.ua-hiw__video video');
    if (v) {
      var p = v.play();
      if (p && p.catch) p.catch(function () {});
      return;
    }
    var f = modal.querySelector('.ua-hiw__video iframe[data-src]');
    if (f && !f.getAttribute('src')) f.setAttribute('src', f.getAttribute('data-src'));
  }

  function stopVideo() {
    var v = modal.querySelector('.ua-hiw__video video');
    if (v) v.pause();
    var yt = modal.querySelector('.ua-hiw__video .js-youtube');
    if (yt && yt.contentWindow) yt.contentWindow.postMessage('{"event":"command","func":"pauseVideo","args":""}', '*');
    var vm = modal.querySelector('.ua-hiw__video .js-vimeo');
    if (vm && vm.contentWindow) vm.contentWindow.postMessage('{"method":"pause"}', '*');
  }

  function open(source) {
    if (!modal.hidden) return;
    lastFocus = document.activeElement;
    modal.hidden = false;
    document.documentElement.classList.add('ua-hiw-lock');
    if (scroller) scroller.scrollTop = 0;
    panel.focus({ preventScroll: true });
    playVideo();
    hideTab(false);
    track('ua_how_it_works_open', source);
    document.dispatchEvent(new CustomEvent('ua-hiw:open'));
  }

  function close() {
    if (modal.hidden) return;
    stopVideo();
    modal.hidden = true;
    document.documentElement.classList.remove('ua-hiw-lock');
    if (location.hash === HASH) history.replaceState(null, '', location.pathname + location.search);
    if (lastFocus && lastFocus.focus) lastFocus.focus({ preventScroll: true });
    document.dispatchEvent(new CustomEvent('ua-hiw:close'));
  }

  function hideTab(forever) {
    if (forever) ls('setItem', DISMISS_KEY, '1');
    else ss('setItem', SEEN_KEY, '1');
    if (!tab || tab.hidden) return;
    tab.classList.remove('is-in');
    setTimeout(function () { tab.hidden = true; }, 450);
  }

  window.uaHowItWorks = { open: open, close: close };

  document.addEventListener('click', function (e) {
    var t = e.target;
    if (t.closest('[data-ua-hiw-dismiss]')) {
      e.preventDefault();
      e.stopPropagation();
      hideTab(true);
      track('ua_how_it_works_tab_dismiss', 'tab');
      return;
    }
    var opener = t.closest('[data-ua-hiw-open]');
    if (opener) {
      e.preventDefault();
      open(opener.getAttribute('data-ua-hiw-open'));
      return;
    }
    if (t.closest('[data-ua-hiw-close]')) {
      e.preventDefault();
      close();
      return;
    }
    if (t.closest('[data-ua-hiw-shop]')) {
      close();
      var grid = document.getElementById('ProductGridContainer') || document.getElementById('lb101-breaks') || document.querySelector('.ua-mb-list, .collection, [id*="product-grid"]');
      if (grid) grid.scrollIntoView({ behavior: 'smooth', block: 'start' });
      return;
    }
    var toc = t.closest('.ua-hiw__toc a');
    if (toc) {
      e.preventDefault();
      var target = modal.querySelector(toc.getAttribute('href'));
      if (target) target.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  });

  document.addEventListener('keydown', function (e) {
    if (!modal.hidden && e.key === 'Escape') close();
  });

  if (location.hash === HASH) open('hash');

  /* Slide-in tab: shown to everyone until they close it with the x (remembered in
     localStorage), and hidden for the rest of a visit once they open the video.
     ?hiw_tab=1 forces it on for testing and clears both. */
  if (tab) {
    var force = /[?&]hiw_tab=1(&|$)/.test(location.search);
    if (force) { ls('removeItem', DISMISS_KEY); ss('removeItem', SEEN_KEY); }
    var dismissed = ls('getItem', DISMISS_KEY) === '1' || ss('getItem', SEEN_KEY) === '1';
    var wrongSize = tab.hasAttribute('data-mobile-only') && window.matchMedia('(min-width: 750px)').matches;
    if (!wrongSize && (force || !dismissed)) {
      setTimeout(function () {
        if (!modal.hidden) return;
        tab.hidden = false;
        /* force a style flush so the slide transition runs from the off-screen
           position; requestAnimationFrame was used here before, but it never
           fires while the page is backgrounded, which left the tab parked
           off-screen */
        void tab.offsetWidth;
        tab.classList.add('is-in');
        track('ua_how_it_works_tab_shown', 'tab');
      }, TAB_DELAY_MS);
    }
  }
})();
